export const capitalizeMessage = (message: string): string => {
  if (!message) return '';
  const capitalizedMessage = message.charAt(0).toUpperCase() + message.slice(1).toLowerCase();
  return capitalizedMessage;
};